export default {
  Ostan: [
    {
      value: 1,
      label: "آذربايجان شرقي",
      country: 1,
    },
    {
      value: 2,
      label: "آذربايجان غربي",
      country: 1,
    },
    { value: 3, label: "اردبيل", country: 1 },
    { value: 4, label: "اصفهان", country: 1 },
    {
      value: 5,
      label: "البرز",
      country: 1,
    },
    { value: 6, label: "ايلام", country: 1 },
    { value: 7, label: "بوشهر", country: 1 },
    {
      value: 8,
      label: "تهران",
      country: 1,
    },
    { value: 9, label: "چهارمحال وبختياري", country: 1 },
    { value: 10, label: "خراسان جنوبي", country: 1 },
    {
      value: 11,
      label: "خراسان رضوي",
      country: 1,
    },
    { value: 12, label: "خراسان شمالي", country: 1 },
    { value: 13, label: "خوزستان", country: 1 },
    {
      value: 14,
      label: "زنجان",
      country: 1,
    },
    { value: 15, label: "سمنان", country: 1 },
    { value: 16, label: "سيستان وبلوچستان", country: 1 },
    {
      value: 17,
      label: "فارس",
      country: 1,
    },
    { value: 18, label: "قزوين", country: 1 },
    { value: 19, label: "قم", country: 1 },
    {
      value: 20,
      label: "کردستان",
      country: 1,
    },
    { value: 21, label: "کرمان", country: 1 },
    { value: 22, label: "کرمانشاه", country: 1 },
    {
      value: 23,
      label: "کهگيلويه وبويراحمد",
      country: 1,
    },
    { value: 24, label: "گلستان", country: 1 },
    { value: 25, label: "گيلان", country: 1 },
    {
      value: 26,
      label: "لرستان",
      country: 1,
    },
    { value: 27, label: "مازندران", country: 1 },
    { value: 28, label: "مرکزي", country: 1 },
    {
      value: 29,
      label: "هرمزگان",
      country: 1,
    },
    { value: 30, label: "همدان", country: 1 },
    { value: 31, label: "يزد", country: 1 },
  ],

  city: [
    { value: 1, label: "آذرشهر", ostan: 1 },
    { value: 2, label: "تيمورلو", ostan: 1 },
    {
      value: 3,
      label: "گوگان",
      ostan: 1,
    },
    { value: 4, label: "ممقان", ostan: 1 },
    { value: 5, label: "اسکو", ostan: 1 },
    {
      value: 6,
      label: "ايلخچي",
      ostan: 1,
    },
    { value: 7, label: "سهند", ostan: 1 },
    { value: 8, label: "اهر", ostan: 1 },
    {
      value: 9,
      label: "هوراند",
      ostan: 1,
    },
    { value: 10, label: "بستان آباد", ostan: 1 },
    { value: 11, label: "تيکمه داش", ostan: 1 },
    {
      value: 12,
      label: "بناب",
      ostan: 1,
    },
    { value: 13, label: "باسمنج", ostan: 1 },
    { value: 14, label: "تبريز", ostan: 1 },
    {
      value: 15,
      label: "خسروشاه",
      ostan: 1,
    },
    { value: 16, label: "سردرود", ostan: 1 },
    { value: 17, label: "جلفا", ostan: 1 },
    {
      value: 18,
      label: "سيه رود",
      ostan: 1,
    },
    { value: 19, label: "هاديشهر", ostan: 1 },
    { value: 20, label: "قره آغاج", ostan: 1 },
    {
      value: 21,
      label: "خمارلو",
      ostan: 1,
    },
    { value: 22, label: "دوزدوزان", ostan: 1 },
    { value: 23, label: "سراب", ostan: 1 },
    {
      value: 24,
      label: "شربيان",
      ostan: 1,
    },
    { value: 25, label: "مهربان", ostan: 1 },
    { value: 26, label: "تسوج", ostan: 1 },
    {
      value: 27,
      label: "خامنه",
      ostan: 1,
    },
    { value: 28, label: "سيس", ostan: 1 },
    { value: 29, label: "شبستر", ostan: 1 },
    {
      value: 30,
      label: "شرفخانه",
      ostan: 1,
    },
    { value: 31, label: "شندآباد", ostan: 1 },
    { value: 32, label: "صوفيان", ostan: 1 },
    {
      value: 33,
      label: "کوزه کنان",
      ostan: 1,
    },
    { value: 34, label: "وايقان", ostan: 1 },
    { value: 35, label: "جوان قلعه", ostan: 1 },
    {
      value: 36,
      label: "عجب شير",
      ostan: 1,
    },
    { value: 37, label: "آبش احمد", ostan: 1 },
    { value: 38, label: "کليبر", ostan: 1 },
    {
      value: 39,
      label: "خداجو(خراجو)",
      ostan: 1,
    },
    { value: 40, label: "مراغه", ostan: 1 },
    { value: 41, label: "بناب مرند", ostan: 1 },
    {
      value: 42,
      label: "زنوز",
      ostan: 1,
    },
    { value: 43, label: "کشکسراي", ostan: 1 },
    { value: 44, label: "مرند", ostan: 1 },
    {
      value: 45,
      label: "يامچي",
      ostan: 1,
    },
    { value: 46, label: "ليلان", ostan: 1 },
    { value: 47, label: "مبارک شهر", ostan: 1 },
    {
      value: 48,
      label: "ملکان",
      ostan: 1,
    },
    { value: 49, label: "آقکند", ostan: 1 },
    { value: 50, label: "اچاچي", ostan: 1 },
    {
      value: 51,
      label: "ترک",
      ostan: 1,
    },
    { value: 52, label: "ترکمانچاي", ostan: 1 },
    { value: 53, label: "ميانه", ostan: 1 },
    {
      value: 54,
      label: "خاروانا",
      ostan: 1,
    },
    { value: 55, label: "ورزقان", ostan: 1 },
    { value: 56, label: "بخشايش", ostan: 1 },
    {
      value: 57,
      label: "خواجه",
      ostan: 1,
    },
    { value: 58, label: "زرنق", ostan: 1 },
    { value: 59, label: "کلوانق", ostan: 1 },
    {
      value: 60,
      label: "هريس",
      ostan: 1,
    },
    { value: 61, label: "نظرکهريزي", ostan: 1 },
    { value: 62, label: "هشترود", ostan: 1 },
    {
      value: 63,
      label: "اروميه",
      ostan: 2,
    },
    { value: 64, label: "سرو", ostan: 2 },
    { value: 65, label: "سيلوانه", ostan: 2 },
    {
      value: 66,
      label: "قوشچي",
      ostan: 2,
    },
    { value: 67, label: "نوشين", ostan: 2 },
    { value: 68, label: "اشنويه", ostan: 2 },
    {
      value: 69,
      label: "نالوس",
      ostan: 2,
    },
    { value: 70, label: "بوکان", ostan: 2 },
    { value: 71, label: "سيمينه", ostan: 2 },
    {
      value: 72,
      label: "پلدشت",
      ostan: 2,
    },
    { value: 73, label: "نازک عليا", ostan: 2 },
    { value: 74, label: "پيرانشهر", ostan: 2 },
    {
      value: 75,
      label: "گردکشانه",
      ostan: 2,
    },
    { value: 76, label: "تکاب", ostan: 2 },
    { value: 77, label: "آواجيق", ostan: 2 },
    {
      value: 78,
      label: "سيه چشمه",
      ostan: 2,
    },
    { value: 79, label: "قره ضياءالدين", ostan: 2 },
    { value: 80, label: "ايواوغلي", ostan: 2 },
    {
      value: 81,
      label: "خوي",
      ostan: 2,
    },
    { value: 82, label: "ديزج ديز", ostan: 2 },
    { value: 83, label: "زرآباد", ostan: 2 },
    {
      value: 84,
      label: "فيرورق",
      ostan: 2,
    },
    { value: 85, label: "قطور", ostan: 2 },
    { value: 86, label: "ربط", ostan: 2 },
    {
      value: 87,
      label: "سردشت",
      ostan: 2,
    },
    { value: 88, label: "ميرآباد", ostan: 2 },
    { value: 89, label: "تازه شهر", ostan: 2 },
    {
      value: 90,
      label: "سلماس",
      ostan: 2,
    },
    { value: 91, label: "شاهين دژ", ostan: 2 },
    { value: 92, label: "کشاورز", ostan: 2 },
    {
      value: 93,
      label: "محمودآباد",
      ostan: 2,
    },
    { value: 94, label: "شوط", ostan: 2 },
    { value: 95, label: "مرگنلر", ostan: 2 },
    {
      value: 96,
      label: "بازرگان",
      ostan: 2,
    },
    { value: 97, label: "ماکو", ostan: 2 },
    { value: 98, label: "خليفان", ostan: 2 },
    {
      value: 99,
      label: "مهاباد",
      ostan: 2,
    },
    { value: 100, label: "باروق", ostan: 2 },
    { value: 101, label: "چهاربرج", ostan: 2 },
    {
      value: 102,
      label: "مياندوآب",
      ostan: 2,
    },
    { value: 103, label: "محمديار", ostan: 2 },
    { value: 104, label: "نقده", ostan: 2 },
    {
      value: 105,
      label: "اردبيل",
      ostan: 3,
    },
    { value: 106, label: "هير", ostan: 3 },
    { value: 107, label: "بيله سوار", ostan: 3 },
    {
      value: 108,
      label: "جعفرآباد",
      ostan: 3,
    },
    { value: 109, label: "اسلام اباد", ostan: 3 },
    { value: 110, label: "اصلاندوز", ostan: 3 },
    {
      value: 111,
      label: "پارس آباد",
      ostan: 3,
    },
    { value: 112, label: "تازه کند", ostan: 3 },
    { value: 113, label: "خلخال", ostan: 3 },
    {
      value: 114,
      label: "کلور",
      ostan: 3,
    },
    { value: 115, label: "هشتجين", ostan: 3 },
    { value: 116, label: "سرعين", ostan: 3 },
    {
      value: 117,
      label: "گيوي",
      ostan: 3,
    },
    { value: 118, label: "تازه کندانگوت", ostan: 3 },
    { value: 119, label: "گرمي", ostan: 3 },
    {
      value: 120,
      label: "رضي",
      ostan: 3,
    },
    { value: 121, label: "فخراباد", ostan: 3 },
    { value: 122, label: "قصابه", ostan: 3 },
    {
      value: 123,
      label: "لاهرود",
      ostan: 3,
    },
    { value: 124, label: "مرادلو", ostan: 3 },
    { value: 125, label: "مشگين شهر", ostan: 3 },
    {
      value: 126,
      label: "آبي بيگلو",
      ostan: 3,
    },
    { value: 127, label: "عنبران", ostan: 3 },
    { value: 128, label: "نمين", ostan: 3 },
    {
      value: 129,
      label: "کوراييم",
      ostan: 3,
    },
    { value: 130, label: "نير", ostan: 3 },
    { value: 131, label: "آران وبيدگل", ostan: 4 },
    {
      value: 132,
      label: "ابوزيدآباد",
      ostan: 4,
    },
    { value: 133, label: "سفيدشهر", ostan: 4 },
    { value: 134, label: "نوش آباد", ostan: 4 },
    {
      value: 135,
      label: "اردستان",
      ostan: 4,
    },
    { value: 136, label: "زواره", ostan: 4 },
    { value: 137, label: "مهاباد", ostan: 4 },
    {
      value: 138,
      label: "اژيه",
      ostan: 4,
    },
    { value: 139, label: "اصفهان", ostan: 4 },
    { value: 140, label: "بهارستان", ostan: 4 },
    {
      value: 141,
      label: "تودشک",
      ostan: 4,
    },
    { value: 142, label: "حسن اباد", ostan: 4 },
    { value: 143, label: "زيار", ostan: 4 },
    {
      value: 144,
      label: "سجزي",
      ostan: 4,
    },
    { value: 145, label: "قهجاورستان", ostan: 4 },
    { value: 146, label: "کوهپايه", ostan: 4 },
    {
      value: 147,
      label: "محمدآباد",
      ostan: 4,
    },
    { value: 148, label: "نصرآباد", ostan: 4 },
    { value: 149, label: "نيک آباد", ostan: 4 },
    {
      value: 150,
      label: "ورزنه",
      ostan: 4,
    },
    { value: 151, label: "هرند", ostan: 4 },
    { value: 152, label: "حبيب آباد", ostan: 4 },
    {
      value: 153,
      label: "خورزوق",
      ostan: 4,
    },
    { value: 154, label: "دستگرد", ostan: 4 },
    { value: 155, label: "دولت آباد", ostan: 4 },
    {
      value: 156,
      label: "سين",
      ostan: 4,
    },
    { value: 157, label: "شاپورآباد", ostan: 4 },
    { value: 158, label: "کمشچه", ostan: 4 },
    {
      value: 159,
      label: "افوس",
      ostan: 4,
    },
    { value: 160, label: "بويين ومياندشت", ostan: 4 },
    { value: 161, label: "تيران", ostan: 4 },
    {
      value: 162,
      label: "رضوانشهر",
      ostan: 4,
    },
    { value: 163, label: "عسگران", ostan: 4 },
    { value: 164, label: "چادگان", ostan: 4 },
    {
      value: 165,
      label: "رزوه",
      ostan: 4,
    },
    { value: 166, label: "اصغرآباد", ostan: 4 },
    { value: 167, label: "خميني شهر", ostan: 4 },
    {
      value: 168,
      label: "درچه",
      ostan: 4,
    },
    { value: 169, label: "کوشک", ostan: 4 },
    { value: 170, label: "خوانسار", ostan: 4 },
    {
      value: 171,
      label: "جندق",
      ostan: 4,
    },
    { value: 172, label: "خور", ostan: 4 },
    { value: 173, label: "فرخي", ostan: 4 },
    {
      value: 174,
      label: "دهاقان",
      ostan: 4,
    },
    { value: 175, label: "گلشن", ostan: 4 },
    { value: 176, label: "حنا", ostan: 4 },
    {
      value: 177,
      label: "سميرم",
      ostan: 4,
    },
    { value: 178, label: "کمه", ostan: 4 },
    { value: 179, label: "ونک", ostan: 4 },
    {
      value: 180,
      label: "شاهين شهر",
      ostan: 4,
    },
    { value: 181, label: "گرگاب", ostan: 4 },
    { value: 182, label: "گزبرخوار", ostan: 4 },
    {
      value: 183,
      label: "لاي بيد",
      ostan: 4,
    },
    { value: 184, label: "ميمه", ostan: 4 },
    { value: 185, label: "وزوان", ostan: 4 },
    {
      value: 186,
      label: "شهرضا",
      ostan: 4,
    },
    { value: 187, label: "منظريه", ostan: 4 },
    { value: 188, label: "داران", ostan: 4 },
    {
      value: 189,
      label: "دامنه",
      ostan: 4,
    },
    { value: 190, label: "برف انبار", ostan: 4 },
    { value: 191, label: "فريدونشهر", ostan: 4 },
    {
      value: 192,
      label: "ابريشم",
      ostan: 4,
    },
    { value: 193, label: "ايمانشهر", ostan: 4 },
    { value: 194, label: "بهاران شهر", ostan: 4 },
    {
      value: 195,
      label: "پيربکران",
      ostan: 4,
    },
    { value: 196, label: "زازران", ostan: 4 },
    { value: 197, label: "فلاورجان", ostan: 4 },
    {
      value: 198,
      label: "قهدريجان",
      ostan: 4,
    },
    { value: 199, label: "کليشادوسودرجان", ostan: 4 },
    { value: 200, label: "برزک", ostan: 4 },
    {
      value: 201,
      label: "جوشقان قالي",
      ostan: 4,
    },
    { value: 202, label: "قمصر", ostan: 4 },
    { value: 203, label: "کاشان", ostan: 4 },
    {
      value: 204,
      label: "کامو و چوگان",
      ostan: 4,
    },
    { value: 205, label: "مشکات", ostan: 4 },
    { value: 206, label: "نياسر", ostan: 4 },
    {
      value: 207,
      label: "گلپايگان",
      ostan: 4,
    },
    { value: 208, label: "گلشهر", ostan: 4 },
    { value: 209, label: "گوگد", ostan: 4 },
    {
      value: 210,
      label: "باغ بهادران",
      ostan: 4,
    },
    { value: 211, label: "باغشاد", ostan: 4 },
    { value: 212, label: "چرمهين", ostan: 4 },
    {
      value: 213,
      label: "چمگردان",
      ostan: 4,
    },
    { value: 214, label: "زاينده رود", ostan: 4 },
    { value: 215, label: "زرين شهر", ostan: 4 },
    {
      value: 216,
      label: "سده لنجان",
      ostan: 4,
    },
    { value: 217, label: "فولادشهر", ostan: 4 },
    { value: 218, label: "ورنامخواست", ostan: 4 },
    {
      value: 219,
      label: "ديزيچه",
      ostan: 4,
    },
    { value: 220, label: "زيباشهر", ostan: 4 },
    { value: 221, label: "طالخونچه", ostan: 4 },
    {
      value: 222,
      label: "کرکوند",
      ostan: 4,
    },
    { value: 223, label: "مبارکه", ostan: 4 },
    { value: 224, label: "مجلسي", ostan: 4 },
    {
      value: 225,
      label: "انارک",
      ostan: 4,
    },
    { value: 226, label: "بافران", ostan: 4 },
    { value: 227, label: "نايين", ostan: 4 },
    {
      value: 228,
      label: "جوزدان",
      ostan: 4,
    },
    { value: 229, label: "دهق", ostan: 4 },
    { value: 230, label: "علويجه", ostan: 4 },
    {
      value: 231,
      label: "کهريزسنگ",
      ostan: 4,
    },
    { value: 232, label: "گلدشت", ostan: 4 },
    { value: 233, label: "نجف آباد", ostan: 4 },
    {
      value: 234,
      label: "بادرود",
      ostan: 4,
    },
    { value: 235, label: "خالدآباد", ostan: 4 },
    { value: 236, label: "طرق رود", ostan: 4 },
    {
      value: 237,
      label: "نطنز",
      ostan: 4,
    },
    { value: 238, label: "اشتهارد", ostan: 5 },
    { value: 239, label: "چهارباغ", ostan: 5 },
    {
      value: 240,
      label: "شهرجديدهشتگرد",
      ostan: 5,
    },
    { value: 241, label: "کوهسار", ostan: 5 },
    { value: 242, label: "گلسار", ostan: 5 },
    {
      value: 243,
      label: "هشتگرد",
      ostan: 5,
    },
    { value: 244, label: "طالقان", ostan: 5 },
    { value: 245, label: "فرديس", ostan: 5 },
    {
      value: 246,
      label: "مشکين دشت",
      ostan: 5,
    },
    { value: 247, label: "آسارا", ostan: 5 },
    { value: 248, label: "کرج", ostan: 5 },
    {
      value: 249,
      label: "کمال شهر",
      ostan: 5,
    },
    { value: 250, label: "گرمدره", ostan: 5 },
    { value: 251, label: "ماهدشت", ostan: 5 },
    {
      value: 252,
      label: "محمدشهر",
      ostan: 5,
    },
    { value: 253, label: "تنکمان", ostan: 5 },
    { value: 254, label: "نظرآباد", ostan: 5 },
    {
      value: 255,
      label: "آبدانان",
      ostan: 6,
    },
    { value: 256, label: "سراب باغ", ostan: 6 },
    { value: 257, label: "مورموري", ostan: 6 },
    {
      value: 258,
      label: "ايلام",
      ostan: 6,
    },
    { value: 259, label: "چوار", ostan: 6 },
    { value: 260, label: "ايوان", ostan: 6 },
    {
      value: 261,
      label: "زرنه",
      ostan: 6,
    },
    { value: 262, label: "بدره", ostan: 6 },
    { value: 263, label: "آسمان آباد", ostan: 6 },
    {
      value: 264,
      label: "بلاوه",
      ostan: 6,
    },
    { value: 265, label: "توحيد", ostan: 6 },
    { value: 266, label: "سرابله", ostan: 6 },
    {
      value: 267,
      label: "شباب",
      ostan: 6,
    },
    { value: 268, label: "دره شهر", ostan: 6 },
    { value: 269, label: "ماژين", ostan: 6 },
    {
      value: 270,
      label: "پهله",
      ostan: 6,
    },
    { value: 271, label: "دهلران", ostan: 6 },
    { value: 272, label: "موسيان", ostan: 6 },
    {
      value: 273,
      label: "ميمه",
      ostan: 6,
    },
    { value: 274, label: "لومار", ostan: 6 },
    { value: 275, label: "ارکواز", ostan: 6 },
    {
      value: 276,
      label: "دلگشا",
      ostan: 6,
    },
    { value: 277, label: "مهر", ostan: 6 },
    { value: 278, label: "صالح آباد", ostan: 6 },
    {
      value: 279,
      label: "مهران",
      ostan: 6,
    },
    { value: 280, label: "بوشهر", ostan: 7 },
    { value: 281, label: "چغادک", ostan: 7 },
    {
      value: 282,
      label: "خارک",
      ostan: 7,
    },
    { value: 283, label: "عالي شهر", ostan: 7 },
    { value: 284, label: "آباد", ostan: 7 },
    {
      value: 285,
      label: "اهرم",
      ostan: 7,
    },
    { value: 286, label: "دلوار", ostan: 7 },
    { value: 287, label: "انارستان", ostan: 7 },
    {
      value: 288,
      label: "جم",
      ostan: 7,
    },
    { value: 289, label: "ريز", ostan: 7 },
    { value: 290, label: "آب پخش", ostan: 7 },
    {
      value: 291,
      label: "برازجان",
      ostan: 7,
    },
    { value: 292, label: "بوشکان", ostan: 7 },
    { value: 293, label: "تنگ ارم", ostan: 7 },
    {
      value: 294,
      label: "دالکي",
      ostan: 7,
    },
    { value: 295, label: "سعد آباد", ostan: 7 },
    { value: 296, label: "شبانکاره", ostan: 7 },
    {
      value: 297,
      label: "کلمه",
      ostan: 7,
    },
    { value: 298, label: "وحدتيه", ostan: 7 },
    { value: 299, label: "بادوله", ostan: 7 },
    {
      value: 300,
      label: "خورموج",
      ostan: 7,
    },
    { value: 301, label: "شنبه", ostan: 7 },
    { value: 302, label: "کاکي", ostan: 7 },
    {
      value: 303,
      label: "آبدان",
      ostan: 7,
    },
    { value: 304, label: "بردخون", ostan: 7 },
    { value: 305, label: "بردستان", ostan: 7 },
    {
      value: 306,
      label: "بندردير",
      ostan: 7,
    },
    { value: 307, label: "دوراهک", ostan: 7 },
    { value: 308, label: "امام حسن", ostan: 7 },
    {
      value: 309,
      label: "بندرديلم",
      ostan: 7,
    },
    { value: 310, label: "عسلويه", ostan: 7 },
    { value: 311, label: "نخل تقي", ostan: 7 },
    {
      value: 312,
      label: "بندرکنگان",
      ostan: 7,
    },
    { value: 313, label: "بنک", ostan: 7 },
    { value: 314, label: "سيراف", ostan: 7 },
    {
      value: 315,
      label: "بندرريگ",
      ostan: 7,
    },
    { value: 316, label: "بندرگناوه", ostan: 7 },
    { value: 317, label: "احمد آباد مستوفي", ostan: 8 },
    {
      value: 318,
      label: "اسلامشهر",
      ostan: 8,
    },
    { value: 319, label: "چهاردانگه", ostan: 8 },
    { value: 320, label: "صالحيه", ostan: 8 },
    {
      value: 321,
      label: "گلستان",
      ostan: 8,
    },
    { value: 322, label: "نسيم شهر", ostan: 8 },
    { value: 323, label: "پاکدشت", ostan: 8 },
    {
      value: 324,
      label: "شريف آباد",
      ostan: 8,
    },
    { value: 325, label: "فرون اباد", ostan: 8 },
    { value: 326, label: "بومهن", ostan: 8 },
    {
      value: 327,
      label: "پرديس",
      ostan: 8,
    },
    { value: 328, label: "پيشوا", ostan: 8 },
    { value: 329, label: "تهران", ostan: 8 },
    {
      value: 330,
      label: "آبسرد",
      ostan: 8,
    },
    { value: 331, label: "آبعلي", ostan: 8 },
    { value: 332, label: "دماوند", ostan: 8 },
    {
      value: 333,
      label: "رودهن",
      ostan: 8,
    },
    { value: 334, label: "کيلان", ostan: 8 },
    { value: 335, label: "پرند", ostan: 8 },
    {
      value: 336,
      label: "رباطکريم",
      ostan: 8,
    },
    { value: 337, label: "نصيرشهر", ostan: 8 },
    { value: 338, label: "باقرشهر", ostan: 8 },
    {
      value: 339,
      label: "حسن آباد",
      ostan: 8,
    },
    { value: 340, label: "ري", ostan: 8 },
    { value: 341, label: "کهريزک", ostan: 8 },
    {
      value: 342,
      label: "تجريش",
      ostan: 8,
    },
    { value: 343, label: "شمشک", ostan: 8 },
    { value: 344, label: "فشم", ostan: 8 },
    {
      value: 345,
      label: "لواسان",
      ostan: 8,
    },
    { value: 346, label: "انديشه", ostan: 8 },
    { value: 347, label: "باغستان", ostan: 8 },
    {
      value: 348,
      label: "شاهدشهر",
      ostan: 8,
    },
    { value: 349, label: "شهريار", ostan: 8 },
    { value: 350, label: "صباشهر", ostan: 8 },
    {
      value: 351,
      label: "فردوسيه",
      ostan: 8,
    },
    { value: 352, label: "وحيديه", ostan: 8 },
    { value: 353, label: "ارجمند", ostan: 8 },
    {
      value: 354,
      label: "فيروزکوه",
      ostan: 8,
    },
    { value: 355, label: "قدس", ostan: 8 },
    { value: 356, label: "قرچک", ostan: 8 },
    {
      value: 357,
      label: "صفادشت",
      ostan: 8,
    },
    { value: 358, label: "ملارد", ostan: 8 },
    { value: 359, label: "جوادآباد", ostan: 8 },
    {
      value: 360,
      label: "ورامين",
      ostan: 8,
    },
    { value: 361, label: "اردل", ostan: 9 },
    { value: 362, label: "دشتک", ostan: 9 },
    {
      value: 363,
      label: "سرخون",
      ostan: 9,
    },
    { value: 364, label: "کاج", ostan: 9 },
    { value: 365, label: "بروجن", ostan: 9 },
    {
      value: 366,
      label: "بلداجي",
      ostan: 9,
    },
    { value: 367, label: "سفيددشت", ostan: 9 },
    { value: 368, label: "فرادبنه", ostan: 9 },
    {
      value: 369,
      label: "گندمان",
      ostan: 9,
    },
    { value: 370, label: "نقنه", ostan: 9 },
    { value: 371, label: "بن", ostan: 9 },
    {
      value: 372,
      label: "وردنجان",
      ostan: 9,
    },
    { value: 373, label: "سامان", ostan: 9 },
    { value: 374, label: "سودجان", ostan: 9 },
    {
      value: 375,
      label: "سورشجان",
      ostan: 9,
    },
    { value: 376, label: "شهرکرد", ostan: 9 },
    { value: 377, label: "طاقانک", ostan: 9 },
    {
      value: 378,
      label: "فرخ شهر",
      ostan: 9,
    },
    { value: 379, label: "کيان", ostan: 9 },
    { value: 380, label: "نافچ", ostan: 9 },
    {
      value: 381,
      label: "هاروني",
      ostan: 9,
    },
    { value: 382, label: "هفشجان", ostan: 9 },
    { value: 383, label: "باباحيدر", ostan: 9 },
    {
      value: 384,
      label: "پردنجان",
      ostan: 9,
    },
    { value: 385, label: "جونقان", ostan: 9 },
    { value: 386, label: "چليچه", ostan: 9 },
    {
      value: 387,
      label: "فارسان",
      ostan: 9,
    },
    { value: 388, label: "گوجان", ostan: 9 },
    { value: 389, label: "بازفت", ostan: 9 },
    {
      value: 390,
      label: "چلگرد",
      ostan: 9,
    },
    { value: 391, label: "صمصامي", ostan: 9 },
    { value: 392, label: "دستنا", ostan: 9 },
    {
      value: 393,
      label: "شلمزار",
      ostan: 9,
    },
    { value: 394, label: "گهرو", ostan: 9 },
    { value: 395, label: "ناغان", ostan: 9 },
    {
      value: 396,
      label: "آلوني",
      ostan: 9,
    },
    { value: 397, label: "سردشت", ostan: 9 },
    { value: 398, label: "لردگان", ostan: 9 },
    {
      value: 399,
      label: "مال خليفه",
      ostan: 9,
    },
    { value: 400, label: "منج", ostan: 9 },
    { value: 401, label: "ارسک", ostan: 10 },
    {
      value: 402,
      label: "بشرويه",
      ostan: 10,
    },
    { value: 403, label: "بيرجند", ostan: 10 },
    { value: 404, label: "خوسف", ostan: 10 },
    {
      value: 405,
      label: "محمدشهر",
      ostan: 10,
    },
    { value: 406, label: "اسديه", ostan: 10 },
    { value: 407, label: "طبس مسينا", ostan: 10 },
    {
      value: 408,
      label: "قهستان",
      ostan: 10,
    },
    { value: 409, label: "گزيک", ostan: 10 },
    { value: 410, label: "حاجي آباد", ostan: 10 },
    {
      value: 411,
      label: "زهان",
      ostan: 10,
    },
    { value: 412, label: "آيسک", ostan: 10 },
    { value: 413, label: "سرايان", ostan: 10 },
    {
      value: 414,
      label: "سه قلعه",
      ostan: 10,
    },
    { value: 415, label: "سربيشه", ostan: 10 },
    { value: 416, label: "مود", ostan: 10 },
    {
      value: 417,
      label: "ديهوک",
      ostan: 10,
    },
    { value: 418, label: "طبس", ostan: 10 },
    { value: 419, label: "عشق آباد", ostan: 10 },
    {
      value: 420,
      label: "اسلاميه",
      ostan: 10,
    },
    { value: 421, label: "فردوس", ostan: 10 },
    { value: 422, label: "آرين شهر", ostan: 10 },
    {
      value: 423,
      label: "اسفدن",
      ostan: 10,
    },
    { value: 424, label: "خضري دشت بياض", ostan: 10 },
    { value: 425, label: "قاين", ostan: 10 },
    {
      value: 426,
      label: "نيمبلوک",
      ostan: 10,
    },
    { value: 427, label: "شوسف", ostan: 10 },
    { value: 428, label: "نهبندان", ostan: 10 },
    {
      value: 429,
      label: "باخرز",
      ostan: 11,
    },
    { value: 430, label: "بجستان", ostan: 11 },
    { value: 431, label: "يونسي", ostan: 11 },
    {
      value: 432,
      label: "انابد",
      ostan: 11,
    },
    { value: 433, label: "بردسکن", ostan: 11 },
    { value: 434, label: "شهراباد", ostan: 11 },
    {
      value: 435,
      label: "شانديز",
      ostan: 11,
    },
    { value: 436, label: "طرقبه", ostan: 11 },
    { value: 437, label: "تايباد", ostan: 11 },
    {
      value: 438,
      label: "کاريز",
      ostan: 11,
    },
    { value: 439, label: "مشهدريزه", ostan: 11 },
    { value: 440, label: "احمدابادصولت", ostan: 11 },
    {
      value: 441,
      label: "تربت جام",
      ostan: 11,
    },
    { value: 442, label: "صالح آباد", ostan: 11 },
    { value: 443, label: "نصرآباد", ostan: 11 },
    {
      value: 444,
      label: "نيل شهر",
      ostan: 11,
    },
    { value: 445, label: "بايک", ostan: 11 },
    { value: 446, label: "تربت حيدريه", ostan: 11 },
    {
      value: 447,
      label: "رباط سنگ",
      ostan: 11,
    },
    { value: 448, label: "کدکن", ostan: 11 },
    { value: 449, label: "جغتاي", ostan: 11 },
    {
      value: 450,
      label: "نقاب",
      ostan: 11,
    },
    { value: 451, label: "چناران", ostan: 11 },
    { value: 452, label: "گلبهار", ostan: 11 },
    {
      value: 453,
      label: "گلمکان",
      ostan: 11,
    },
    { value: 454, label: "خليل آباد", ostan: 11 },
    { value: 455, label: "کندر", ostan: 11 },
    {
      value: 456,
      label: "خواف",
      ostan: 11,
    },
    { value: 457, label: "سلامي", ostan: 11 },
    { value: 458, label: "سنگان", ostan: 11 },
    {
      value: 459,
      label: "قاسم آباد",
      ostan: 11,
    },
    { value: 460, label: "نشتيفان", ostan: 11 },
    { value: 461, label: "سلطان آباد", ostan: 11 },
    {
      value: 462,
      label: "داورزن",
      ostan: 11,
    },
    { value: 463, label: "چاپشلو", ostan: 11 },
    { value: 464, label: "درگز", ostan: 11 },
    {
      value: 465,
      label: "لطف آباد",
      ostan: 11,
    },
    { value: 466, label: "نوخندان", ostan: 11 },
    { value: 467, label: "جنگل", ostan: 11 },
    {
      value: 468,
      label: "رشتخوار",
      ostan: 11,
    },
    { value: 469, label: "دولت آباد", ostan: 11 },
    { value: 470, label: "روداب", ostan: 11 },
    {
      value: 471,
      label: "سبزوار",
      ostan: 11,
    },
    { value: 472, label: "ششتمد", ostan: 11 },
    { value: 473, label: "سرخس", ostan: 11 },
    {
      value: 474,
      label: "مزدآوند",
      ostan: 11,
    },
    { value: 475, label: "سفيدسنگ", ostan: 11 },
    { value: 476, label: "فرهادگرد", ostan: 11 },
    {
      value: 477,
      label: "فريمان",
      ostan: 11,
    },
    { value: 478, label: "قلندرآباد", ostan: 11 },
    { value: 479, label: "فيروزه", ostan: 11 },
    {
      value: 480,
      label: "همت آباد",
      ostan: 11,
    },
    { value: 481, label: "باجگيران", ostan: 11 },
    { value: 482, label: "قوچان", ostan: 11 },
    {
      value: 483,
      label: "ريوش",
      ostan: 11,
    },
    { value: 484, label: "کاشمر", ostan: 11 },
    { value: 485, label: "شهرزو", ostan: 11 },
    {
      value: 486,
      label: "کلات",
      ostan: 11,
    },
    { value: 487, label: "بيدخت", ostan: 11 },
    { value: 488, label: "کاخک", ostan: 11 },
    {
      value: 489,
      label: "گناباد",
      ostan: 11,
    },
    { value: 490, label: "رضويه", ostan: 11 },
    { value: 491, label: "مشهد", ostan: 11 },
    {
      value: 492,
      label: "مشهد ثامن",
      ostan: 11,
    },
    { value: 493, label: "ملک آباد", ostan: 11 },
    { value: 494, label: "شادمهر", ostan: 11 },
    {
      value: 495,
      label: "فيض آباد",
      ostan: 11,
    },
    { value: 496, label: "بار", ostan: 11 },
    { value: 497, label: "چکنه", ostan: 11 },
    {
      value: 498,
      label: "خرو",
      ostan: 11,
    },
    { value: 499, label: "درود", ostan: 11 },
    { value: 500, label: "عشق آباد", ostan: 11 },
    {
      value: 501,
      label: "قدمگاه",
      ostan: 11,
    },
    { value: 502, label: "نيشابور", ostan: 11 },
    { value: 503, label: "اسفراين", ostan: 12 },
    {
      value: 504,
      label: "صفي آباد",
      ostan: 12,
    },
    { value: 505, label: "بجنورد", ostan: 12 },
    { value: 506, label: "چناران شهر", ostan: 12 },
    {
      value: 507,
      label: "حصارگرمخان",
      ostan: 12,
    },
    { value: 508, label: "جاجرم", ostan: 12 },
    { value: 509, label: "سنخواست", ostan: 12 },
    {
      value: 510,
      label: "شوقان",
      ostan: 12,
    },
    { value: 511, label: "راز", ostan: 12 },
    { value: 512, label: "زيارت", ostan: 12 },
    {
      value: 513,
      label: "شيروان",
      ostan: 12,
    },
    { value: 514, label: "قوشخانه", ostan: 12 },
    { value: 515, label: "لوجلي", ostan: 12 },
    {
      value: 516,
      label: "تيتکانلو",
      ostan: 12,
    },
    { value: 517, label: "فاروج", ostan: 12 },
    { value: 518, label: "ايور", ostan: 12 },
    {
      value: 519,
      label: "درق",
      ostan: 12,
    },
    { value: 520, label: "گرمه", ostan: 12 },
    { value: 521, label: "آشخانه", ostan: 12 },
    {
      value: 522,
      label: "آوا",
      ostan: 12,
    },
    { value: 523, label: "پيش قلعه", ostan: 12 },
    { value: 524, label: "قاضي", ostan: 12 },
    {
      value: 525,
      label: "آبادان",
      ostan: 13,
    },
    { value: 526, label: "اروندکنار", ostan: 13 },
    { value: 527, label: "چويبده", ostan: 13 },
    {
      value: 528,
      label: "آغاجاري",
      ostan: 13,
    },
    { value: 529, label: "اميديه", ostan: 13 },
    { value: 530, label: "جايزان", ostan: 13 },
    {
      value: 531,
      label: "آبژدان",
      ostan: 13,
    },
    { value: 532, label: "قلعه خواجه", ostan: 13 },
    { value: 533, label: "آزادي", ostan: 13 },
    {
      value: 534,
      label: "انديمشک",
      ostan: 13,
    },
    { value: 535, label: "بيدروبه", ostan: 13 },
    { value: 536, label: "چم گلک", ostan: 13 },
    {
      value: 537,
      label: "حسينيه",
      ostan: 13,
    },
    { value: 538, label: "الهايي", ostan: 13 },
    { value: 539, label: "اهواز", ostan: 13 },
    {
      value: 540,
      label: "ايذه",
      ostan: 13,
    },
    { value: 541, label: "دهدز", ostan: 13 },
    { value: 542, label: "باغ ملک", ostan: 13 },
    {
      value: 543,
      label: "صيدون",
      ostan: 13,
    },
    { value: 544, label: "قلعه تل", ostan: 13 },
    { value: 545, label: "ميداود", ostan: 13 },
    {
      value: 546,
      label: "شيبان",
      ostan: 13,
    },
    { value: 547, label: "ملاثاني", ostan: 13 },
    { value: 548, label: "ويس", ostan: 13 },
    {
      value: 549,
      label: "بندرامام خميني",
      ostan: 13,
    },
    { value: 550, label: "بندرماهشهر", ostan: 13 },
    { value: 551, label: "چمران", ostan: 13 },
    {
      value: 552,
      label: "بهبهان",
      ostan: 13,
    },
    { value: 553, label: "تشان", ostan: 13 },
    { value: 554, label: "سردشت", ostan: 13 },
    {
      value: 555,
      label: "منصوريه",
      ostan: 13,
    },
    { value: 556, label: "حميديه", ostan: 13 },
    { value: 557, label: "خرمشهر", ostan: 13 },
    {
      value: 558,
      label: "مقاومت",
      ostan: 13,
    },
    { value: 559, label: "مينوشهر", ostan: 13 },
    { value: 560, label: "چغاميش", ostan: 13 },
    {
      value: 561,
      label: "حمزه",
      ostan: 13,
    },
    { value: 562, label: "دزفول", ostan: 13 },
    { value: 563, label: "سالند", ostan: 13 },
    {
      value: 564,
      label: "سياه منصور",
      ostan: 13,
    },
    { value: 565, label: "شمس آباد", ostan: 13 },
    { value: 566, label: "شهر امام", ostan: 13 },
    {
      value: 567,
      label: "صفي آباد",
      ostan: 13,
    },
    { value: 568, label: "ميانرود", ostan: 13 },
    { value: 569, label: "ابوحميظه", ostan: 13 },
    {
      value: 570,
      label: "بستان",
      ostan: 13,
    },
    { value: 571, label: "سوسنگرد", ostan: 13 },
    { value: 572, label: "کوت سيدنعيم", ostan: 13 },
    {
      value: 573,
      label: "رامشير",
      ostan: 13,
    },
    { value: 574, label: "مشراگه", ostan: 13 },
    { value: 575, label: "رامهرمز", ostan: 13 },
    {
      value: 576,
      label: "خنافره",
      ostan: 13,
    },
    { value: 577, label: "دارخوين", ostan: 13 },
    { value: 578, label: "شادگان", ostan: 13 },
    {
      value: 579,
      label: "الوان",
      ostan: 13,
    },
    { value: 580, label: "حر", ostan: 13 },
    { value: 581, label: "شاوور", ostan: 13 },
    {
      value: 582,
      label: "شوش",
      ostan: 13,
    },
    { value: 583, label: "فتح المبين", ostan: 13 },
    { value: 584, label: "سرداران", ostan: 13 },
    {
      value: 585,
      label: "شرافت",
      ostan: 13,
    },
    { value: 586, label: "شوشتر", ostan: 13 },
    { value: 587, label: "گوريه", ostan: 13 },
    {
      value: 588,
      label: "کوت عبداله",
      ostan: 13,
    },
    { value: 589, label: "ترکالکي", ostan: 13 },
    { value: 590, label: "جنت مکان", ostan: 13 },
    {
      value: 591,
      label: "سماله",
      ostan: 13,
    },
    { value: 592, label: "صالح شهر", ostan: 13 },
    { value: 593, label: "گتوند", ostan: 13 },
    {
      value: 594,
      label: "لالي",
      ostan: 13,
    },
    { value: 595, label: "گلگير", ostan: 13 },
    { value: 596, label: "مسجدسليمان", ostan: 13 },
    {
      value: 597,
      label: "هفتگل",
      ostan: 13,
    },
    { value: 598, label: "زهره", ostan: 13 },
    { value: 599, label: "هنديجان", ostan: 13 },
    {
      value: 600,
      label: "رفيع",
      ostan: 13,
    },
    { value: 601, label: "هويزه", ostan: 13 },
    { value: 602, label: "ابهر", ostan: 14 },
    {
      value: 603,
      label: "صايين قلعه",
      ostan: 14,
    },
    { value: 604, label: "هيدج", ostan: 14 },
    { value: 605, label: "حلب", ostan: 14 },
    {
      value: 606,
      label: "زرين آباد",
      ostan: 14,
    },
    { value: 607, label: "زرين رود", ostan: 14 },
    { value: 608, label: "سجاس", ostan: 14 },
    {
      value: 609,
      label: "سهرورد",
      ostan: 14,
    },
    { value: 610, label: "قيدار", ostan: 14 },
    { value: 611, label: "کرسف", ostan: 14 },
    {
      value: 612,
      label: "گرماب",
      ostan: 14,
    },
    { value: 613, label: "نوربهار", ostan: 14 },
    { value: 614, label: "خرمدره", ostan: 14 },
    {
      value: 615,
      label: "ارمغانخانه",
      ostan: 14,
    },
    { value: 616, label: "زنجان", ostan: 14 },
    { value: 617, label: "نيک پي", ostan: 14 },
    {
      value: 618,
      label: "سلطانيه",
      ostan: 14,
    },
    { value: 619, label: "آب بر", ostan: 14 },
    { value: 620, label: "چورزق", ostan: 14 },
    {
      value: 621,
      label: "دندي",
      ostan: 14,
    },
    { value: 622, label: "ماه نشان", ostan: 14 },
    { value: 623, label: "آرادان", ostan: 15 },
    {
      value: 624,
      label: "کهن آباد",
      ostan: 15,
    },
    { value: 625, label: "اميريه", ostan: 15 },
    { value: 626, label: "دامغان", ostan: 15 },
    {
      value: 627,
      label: "ديباج",
      ostan: 15,
    },
    { value: 628, label: "کلاته", ostan: 15 },
    { value: 629, label: "سرخه", ostan: 15 },
    {
      value: 630,
      label: "سمنان",
      ostan: 15,
    },
    { value: 631, label: "بسطام", ostan: 15 },
    { value: 632, label: "بيارجمند", ostan: 15 },
    {
      value: 633,
      label: "روديان",
      ostan: 15,
    },
    { value: 634, label: "شاهرود", ostan: 15 },
    { value: 635, label: "کلاته خيج", ostan: 15 },
    {
      value: 636,
      label: "مجن",
      ostan: 15,
    },
    { value: 637, label: "ايوانکي", ostan: 15 },
    { value: 638, label: "گرمسار", ostan: 15 },
    {
      value: 639,
      label: "درجزين",
      ostan: 15,
    },
    { value: 640, label: "شهميرزاد", ostan: 15 },
    { value: 641, label: "مهدي شهر", ostan: 15 },
    {
      value: 642,
      label: "ميامي",
      ostan: 15,
    },
    { value: 643, label: "ايرانشهر", ostan: 16 },
    { value: 644, label: "بزمان", ostan: 16 },
    {
      value: 645,
      label: "بمپور",
      ostan: 16,
    },
    { value: 646, label: "محمدان", ostan: 16 },
    { value: 647, label: "چابهار", ostan: 16 },
    {
      value: 648,
      label: "نگور",
      ostan: 16,
    },
    { value: 649, label: "خاش", ostan: 16 },
    { value: 650, label: "نوک آباد", ostan: 16 },
    {
      value: 651,
      label: "گلمورتي",
      ostan: 16,
    },
    { value: 652, label: "بنجار", ostan: 16 },
    { value: 653, label: "زابل", ostan: 16 },
    {
      value: 654,
      label: "زاهدان",
      ostan: 16,
    },
    { value: 655, label: "نصرت آباد", ostan: 16 },
    { value: 656, label: "زهک", ostan: 16 },
    {
      value: 657,
      label: "جالق",
      ostan: 16,
    },
    { value: 658, label: "سراوان", ostan: 16 },
    { value: 659, label: "سيرکان", ostan: 16 },
    {
      value: 660,
      label: "گشت",
      ostan: 16,
    },
    { value: 661, label: "محمدي", ostan: 16 },
    { value: 662, label: "پيشين", ostan: 16 },
    {
      value: 663,
      label: "راسک",
      ostan: 16,
    },
    { value: 664, label: "سرباز", ostan: 16 },
    { value: 665, label: "سوران", ostan: 16 },
    {
      value: 666,
      label: "هيدوچ",
      ostan: 16,
    },
    { value: 667, label: "فنوج", ostan: 16 },
    { value: 668, label: "قصرقند", ostan: 16 },
    {
      value: 669,
      label: "زرآباد",
      ostan: 16,
    },
    { value: 670, label: "کنارک", ostan: 16 },
    { value: 671, label: "مهرستان", ostan: 16 },
    {
      value: 672,
      label: "ميرجاوه",
      ostan: 16,
    },
    { value: 673, label: "اسپکه", ostan: 16 },
    { value: 674, label: "بنت", ostan: 16 },
    {
      value: 675,
      label: "نيک شهر",
      ostan: 16,
    },
    { value: 676, label: "اديمي", ostan: 16 },
    { value: 677, label: "شهرک علي اکبر", ostan: 16 },
    {
      value: 678,
      label: "محمدآباد",
      ostan: 16,
    },
    { value: 679, label: "دوست محمد", ostan: 16 },
    { value: 680, label: "آباده", ostan: 17 },
    {
      value: 681,
      label: "ايزدخواست",
      ostan: 17,
    },
    { value: 682, label: "بهمن", ostan: 17 },
    { value: 683, label: "سورمق", ostan: 17 },
    {
      value: 684,
      label: "صغاد",
      ostan: 17,
    },
    { value: 685, label: "ارسنجان", ostan: 17 },
    { value: 686, label: "استهبان", ostan: 17 },
    {
      value: 687,
      label: "ايج",
      ostan: 17,
    },
    { value: 688, label: "رونيز", ostan: 17 },
    { value: 689, label: "اقليد", ostan: 17 },
    {
      value: 690,
      label: "حسن اباد",
      ostan: 17,
    },
    { value: 691, label: "دژکرد", ostan: 17 },
    { value: 692, label: "سده", ostan: 17 },
    {
      value: 693,
      label: "بوانات",
      ostan: 17,
    },
    { value: 694, label: "حسامي", ostan: 17 },
    { value: 695, label: "کره اي", ostan: 17 },
    {
      value: 696,
      label: "مزايجان",
      ostan: 17,
    },
    { value: 697, label: "سعادت شهر", ostan: 17 },
    { value: 698, label: "مادرسليمان", ostan: 17 },
    {
      value: 699,
      label: "باب انار",
      ostan: 17,
    },
    { value: 700, label: "جهرم", ostan: 17 },
    { value: 701, label: "خاوران", ostan: 17 },
    {
      value: 702,
      label: "دوزه",
      ostan: 17,
    },
    { value: 703, label: "قطب آباد", ostan: 17 },
    { value: 704, label: "خرامه", ostan: 17 },
    {
      value: 705,
      label: "سلطان شهر",
      ostan: 17,
    },
    { value: 706, label: "صفاشهر", ostan: 17 },
    { value: 707, label: "قادراباد", ostan: 17 },
    {
      value: 708,
      label: "خنج",
      ostan: 17,
    },
    { value: 709, label: "جنت شهر", ostan: 17 },
    { value: 710, label: "داراب", ostan: 17 },
    {
      value: 711,
      label: "دوبرجي",
      ostan: 17,
    },
    { value: 712, label: "فدامي", ostan: 17 },
    { value: 713, label: "کوپن", ostan: 17 },
    {
      value: 714,
      label: "مصيري",
      ostan: 17,
    },
    { value: 715, label: "حاجي آباد", ostan: 17 },
    { value: 716, label: "دبيران", ostan: 17 },
    {
      value: 717,
      label: "شهرپير",
      ostan: 17,
    },
    { value: 718, label: "اردکان", ostan: 17 },
    { value: 719, label: "بيضا", ostan: 17 },
    {
      value: 720,
      label: "هماشهر",
      ostan: 17,
    },
    { value: 721, label: "سروستان", ostan: 17 },
    { value: 722, label: "کوهنجان", ostan: 17 },
    {
      value: 723,
      label: "خانه زنيان",
      ostan: 17,
    },
    { value: 724, label: "داريان", ostan: 17 },
    { value: 725, label: "زرقان", ostan: 17 },
    {
      value: 726,
      label: "شهرصدرا",
      ostan: 17,
    },
    { value: 727, label: "شيراز", ostan: 17 },
    { value: 728, label: "لپويي", ostan: 17 },
    {
      value: 729,
      label: "دهرم",
      ostan: 17,
    },
    { value: 730, label: "فراشبند", ostan: 17 },
    { value: 731, label: "نوجين", ostan: 17 },
    {
      value: 732,
      label: "زاهدشهر",
      ostan: 17,
    },
    { value: 733, label: "ششده", ostan: 17 },
    { value: 734, label: "فسا", ostan: 17 },
    {
      value: 735,
      label: "قره بلاغ",
      ostan: 17,
    },
    { value: 736, label: "ميانشهر", ostan: 17 },
    { value: 737, label: "نوبندگان", ostan: 17 },
    {
      value: 738,
      label: "فيروزآباد",
      ostan: 17,
    },
    { value: 739, label: "ميمند", ostan: 17 },
    { value: 740, label: "افزر", ostan: 17 },
    {
      value: 741,
      label: "امام شهر",
      ostan: 17,
    },
    { value: 742, label: "قير", ostan: 17 },
    { value: 743, label: "کارزين (فتح آباد)", ostan: 17 },
    {
      value: 744,
      label: "مبارک آبادديز",
      ostan: 17,
    },
    { value: 745, label: "بالاده", ostan: 17 },
    { value: 746, label: "خشت", ostan: 17 },
    {
      value: 747,
      label: "قايميه",
      ostan: 17,
    },
    { value: 748, label: "کازرون", ostan: 17 },
    { value: 749, label: "کنارتخته", ostan: 17 },
    {
      value: 750,
      label: "نودان",
      ostan: 17,
    },
    { value: 751, label: "کوار", ostan: 17 },
    { value: 752, label: "گراش", ostan: 17 },
    {
      value: 753,
      label: "اوز",
      ostan: 17,
    },
    { value: 754, label: "بنارويه", ostan: 17 },
    { value: 755, label: "بيرم", ostan: 17 },
    {
      value: 756,
      label: "جويم",
      ostan: 17,
    },
    { value: 757, label: "خور", ostan: 17 },
    { value: 758, label: "عمادده", ostan: 17 },
    {
      value: 759,
      label: "لار",
      ostan: 17,
    },
    { value: 760, label: "لطيفي", ostan: 17 },
    { value: 761, label: "اشکنان", ostan: 17 },
    {
      value: 762,
      label: "اهل",
      ostan: 17,
    },
    { value: 763, label: "علامرودشت", ostan: 17 },
    { value: 764, label: "لامرد", ostan: 17 },
    {
      value: 765,
      label: "خانيمن",
      ostan: 17,
    },
    { value: 766, label: "رامجرد", ostan: 17 },
    { value: 767, label: "سيدان", ostan: 17 },
    {
      value: 768,
      label: "کامفيروز",
      ostan: 17,
    },
    { value: 769, label: "مرودشت", ostan: 17 },
    { value: 770, label: "بابامنير", ostan: 17 },
    {
      value: 771,
      label: "خومه زار",
      ostan: 17,
    },
    { value: 772, label: "نورآباد", ostan: 17 },
    { value: 773, label: "اسير", ostan: 17 },
    {
      value: 774,
      label: "خوزي",
      ostan: 17,
    },
    { value: 775, label: "گله دار", ostan: 17 },
    { value: 776, label: "مهر", ostan: 17 },
    {
      value: 777,
      label: "وراوي",
      ostan: 17,
    },
    { value: 778, label: "آباده طشک", ostan: 17 },
    { value: 779, label: "قطرويه", ostan: 17 },
    {
      value: 780,
      label: "مشکان",
      ostan: 17,
    },
    { value: 781, label: "ني ريز", ostan: 17 },
    { value: 782, label: "آبيک", ostan: 18 },
    {
      value: 783,
      label: "خاکعلي",
      ostan: 18,
    },
    { value: 784, label: "آبگرم", ostan: 18 },
    { value: 785, label: "آوج", ostan: 18 },
    {
      value: 786,
      label: "الوند",
      ostan: 18,
    },
    { value: 787, label: "بيدستان", ostan: 18 },
    { value: 788, label: "شريفيه", ostan: 18 },
    {
      value: 789,
      label: "محمديه",
      ostan: 18,
    },
    { value: 790, label: "ارداق", ostan: 18 },
    { value: 791, label: "بويين زهرا", ostan: 18 },
    {
      value: 792,
      label: "دانسفهان",
      ostan: 18,
    },
    { value: 793, label: "سگزآباد", ostan: 18 },
    { value: 794, label: "شال", ostan: 18 },
    {
      value: 795,
      label: "اسفرورين",
      ostan: 18,
    },
    { value: 796, label: "تاکستان", ostan: 18 },
    { value: 797, label: "خرمدشت", ostan: 18 },
    {
      value: 798,
      label: "ضياڈآباد",
      ostan: 18,
    },
    { value: 799, label: "نرجه", ostan: 18 },
    { value: 800, label: "اقباليه", ostan: 18 },
    {
      value: 801,
      label: "رازميان",
      ostan: 18,
    },
    { value: 802, label: "سيردان", ostan: 18 },
    { value: 803, label: "قزوين", ostan: 18 },
    {
      value: 804,
      label: "کوهين",
      ostan: 18,
    },
    { value: 805, label: "محمودآبادنمونه", ostan: 18 },
    { value: 806, label: "معلم کلايه", ostan: 18 },
    {
      value: 807,
      label: "جعفريه",
      ostan: 19,
    },
    { value: 808, label: "دستجرد", ostan: 19 },
    { value: 809, label: "سلفچگان", ostan: 19 },
    {
      value: 810,
      label: "قم",
      ostan: 19,
    },
    { value: 811, label: "قنوات", ostan: 19 },
    { value: 812, label: "کهک", ostan: 19 },
    {
      value: 813,
      label: "آرمرده",
      ostan: 20,
    },
    { value: 814, label: "بانه", ostan: 20 },
    { value: 815, label: "بويين سفلي", ostan: 20 },
    {
      value: 816,
      label: "کاني سور",
      ostan: 20,
    },
    { value: 817, label: "بابارشاني", ostan: 20 },
    { value: 818, label: "بيجار", ostan: 20 },
    {
      value: 819,
      label: "پيرتاج",
      ostan: 20,
    },
    { value: 820, label: "توپ آغاج", ostan: 20 },
    { value: 821, label: "ياسوکند", ostan: 20 },
    {
      value: 822,
      label: "بلبان آباد",
      ostan: 20,
    },
    { value: 823, label: "دهگلان", ostan: 20 },
    { value: 824, label: "ديواندره", ostan: 20 },
    {
      value: 825,
      label: "زرينه",
      ostan: 20,
    },
    { value: 826, label: "اورامان تخت", ostan: 20 },
    { value: 827, label: "سروآباد", ostan: 20 },
    {
      value: 828,
      label: "سقز",
      ostan: 20,
    },
    { value: 829, label: "صاحب", ostan: 20 },
    { value: 830, label: "سنندج", ostan: 20 },
    {
      value: 831,
      label: "شويشه",
      ostan: 20,
    },
    { value: 832, label: "دزج", ostan: 20 },
    { value: 833, label: "دلبران", ostan: 20 },
    {
      value: 834,
      label: "سريش آباد",
      ostan: 20,
    },
    { value: 835, label: "قروه", ostan: 20 },
    { value: 836, label: "کامياران", ostan: 20 },
    {
      value: 837,
      label: "موچش",
      ostan: 20,
    },
    { value: 838, label: "برده رشه", ostan: 20 },
    { value: 839, label: "چناره", ostan: 20 },
    {
      value: 840,
      label: "کاني دينار",
      ostan: 20,
    },
    { value: 841, label: "مريوان", ostan: 20 },
    { value: 842, label: "ارزوييه", ostan: 21 },
    {
      value: 843,
      label: "امين شهر",
      ostan: 21,
    },
    { value: 844, label: "انار", ostan: 21 },
    { value: 845, label: "بافت", ostan: 21 },
    {
      value: 846,
      label: "بزنجان",
      ostan: 21,
    },
    { value: 847, label: "بردسير", ostan: 21 },
    { value: 848, label: "دشتکار", ostan: 21 },
    {
      value: 849,
      label: "گلزار",
      ostan: 21,
    },
    { value: 850, label: "لاله زار", ostan: 21 },
    { value: 851, label: "نگار", ostan: 21 },
    {
      value: 852,
      label: "بروات",
      ostan: 21,
    },
    { value: 853, label: "بم", ostan: 21 },
    { value: 854, label: "بلوک", ostan: 21 },
    {
      value: 855,
      label: "جبالبارز",
      ostan: 21,
    },
    { value: 856, label: "جيرفت", ostan: 21 },
    { value: 857, label: "درب بهشت", ostan: 21 },
    {
      value: 858,
      label: "رابر",
      ostan: 21,
    },
    { value: 859, label: "هنزا", ostan: 21 },
    { value: 860, label: "راور", ostan: 21 },
    {
      value: 861,
      label: "هجدک",
      ostan: 21,
    },
    { value: 862, label: "بهرمان", ostan: 21 },
    { value: 863, label: "رفسنجان", ostan: 21 },
    {
      value: 864,
      label: "صفاييه",
      ostan: 21,
    },
    { value: 865, label: "کشکوييه", ostan: 21 },
    { value: 866, label: "مس سرچشمه", ostan: 21 },
    {
      value: 867,
      label: "رودبار",
      ostan: 21,
    },
    { value: 868, label: "زهکلوت", ostan: 21 },
    { value: 869, label: "گنبکي", ostan: 21 },
    {
      value: 870,
      label: "محمدآباد",
      ostan: 21,
    },
    { value: 871, label: "خانوک", ostan: 21 },
    { value: 872, label: "ريحان", ostan: 21 },
    {
      value: 873,
      label: "زرند",
      ostan: 21,
    },
    { value: 874, label: "يزدان شهر", ostan: 21 },
    { value: 875, label: "بلورد", ostan: 21 },
    {
      value: 876,
      label: "پاريز",
      ostan: 21,
    },
    { value: 877, label: "خواجو شهر", ostan: 21 },
    { value: 878, label: "زيدآباد", ostan: 21 },
    {
      value: 879,
      label: "سيرجان",
      ostan: 21,
    },
    { value: 880, label: "نجف شهر", ostan: 21 },
    { value: 881, label: "هماشهر", ostan: 21 },
    {
      value: 882,
      label: "جوزم",
      ostan: 21,
    },
    { value: 883, label: "خاتون اباد", ostan: 21 },
    { value: 884, label: "خورسند", ostan: 21 },
    {
      value: 885,
      label: "دهج",
      ostan: 21,
    },
    { value: 886, label: "شهربابک", ostan: 21 },
    { value: 887, label: "دوساري", ostan: 21 },
    {
      value: 888,
      label: "عنبرآباد",
      ostan: 21,
    },
    { value: 889, label: "مردهک", ostan: 21 },
    { value: 890, label: "فارياب", ostan: 21 },
    {
      value: 891,
      label: "فهرج",
      ostan: 21,
    },
    { value: 892, label: "قلعه گنج", ostan: 21 },
    { value: 893, label: "اختيارآباد", ostan: 21 },
    {
      value: 894,
      label: "اندوهجرد",
      ostan: 21,
    },
    { value: 895, label: "باغين", ostan: 21 },
    { value: 896, label: "جوپار", ostan: 21 },
    {
      value: 897,
      label: "چترود",
      ostan: 21,
    },
    { value: 898, label: "راين", ostan: 21 },
    { value: 899, label: "زنگي آباد", ostan: 21 },
    {
      value: 900,
      label: "شهداد",
      ostan: 21,
    },
    { value: 901, label: "کاظم آباد", ostan: 21 },
    { value: 902, label: "کرمان", ostan: 21 },
    {
      value: 903,
      label: "گلباف",
      ostan: 21,
    },
    { value: 904, label: "ماهان", ostan: 21 },
    { value: 905, label: "محي آباد", ostan: 21 },
    {
      value: 906,
      label: "کوهبنان",
      ostan: 21,
    },
    { value: 907, label: "کيانشهر", ostan: 21 },
    { value: 908, label: "کهنوج", ostan: 21 },
    {
      value: 909,
      label: "منوجان",
      ostan: 21,
    },
    { value: 910, label: "نودژ", ostan: 21 },
    { value: 911, label: "نرماشير", ostan: 21 },
    {
      value: 912,
      label: "نظام شهر",
      ostan: 21,
    },
    { value: 913, label: "اسلام آبادغرب", ostan: 22 },
    { value: 914, label: "حميل", ostan: 22 },
    {
      value: 915,
      label: "بانوره",
      ostan: 22,
    },
    { value: 916, label: "باينگان", ostan: 22 },
    { value: 917, label: "پاوه", ostan: 22 },
    {
      value: 918,
      label: "نودشه",
      ostan: 22,
    },
    { value: 919, label: "نوسود", ostan: 22 },
    { value: 920, label: "ازگله", ostan: 22 },
    {
      value: 921,
      label: "تازه آباد",
      ostan: 22,
    },
    { value: 922, label: "جوانرود", ostan: 22 },
    { value: 923, label: "ريجاب", ostan: 22 },
    {
      value: 924,
      label: "کرند",
      ostan: 22,
    },
    { value: 925, label: "گهواره", ostan: 22 },
    { value: 926, label: "روانسر", ostan: 22 },
    {
      value: 927,
      label: "شاهو",
      ostan: 22,
    },
    { value: 928, label: "سرپل ذهاب", ostan: 22 },
    { value: 929, label: "سطر", ostan: 22 },
    {
      value: 930,
      label: "سنقر",
      ostan: 22,
    },
    { value: 931, label: "صحنه", ostan: 22 },
    { value: 932, label: "ميان راهان", ostan: 22 },
    {
      value: 933,
      label: "سومار",
      ostan: 22,
    },
    { value: 934, label: "قصرشيرين", ostan: 22 },
    { value: 935, label: "رباط", ostan: 22 },
    {
      value: 936,
      label: "کرمانشاه",
      ostan: 22,
    },
    { value: 937, label: "کوزران", ostan: 22 },
    { value: 938, label: "هلشي", ostan: 22 },
    {
      value: 939,
      label: "کنگاور",
      ostan: 22,
    },
    { value: 940, label: "گودين", ostan: 22 },
    { value: 941, label: "سرمست", ostan: 22 },
    {
      value: 942,
      label: "گيلانغرب",
      ostan: 22,
    },
    { value: 943, label: "بيستون", ostan: 22 },
    { value: 944, label: "هرسين", ostan: 22 },
    {
      value: 945,
      label: "باشت",
      ostan: 23,
    },
    { value: 946, label: "چيتاب", ostan: 23 },
    { value: 947, label: "گراب سفلي", ostan: 23 },
    {
      value: 948,
      label: "مادوان",
      ostan: 23,
    },
    { value: 949, label: "مارگون", ostan: 23 },
    { value: 950, label: "ياسوج", ostan: 23 },
    {
      value: 951,
      label: "ليکک",
      ostan: 23,
    },
    { value: 952, label: "چرام", ostan: 23 },
    { value: 953, label: "سرفارياب", ostan: 23 },
    {
      value: 954,
      label: "پاتاوه",
      ostan: 23,
    },
    { value: 955, label: "سي سخت", ostan: 23 },
    { value: 956, label: "دهدشت", ostan: 23 },
    {
      value: 957,
      label: "ديشموک",
      ostan: 23,
    },
    { value: 958, label: "سوق", ostan: 23 },
    { value: 959, label: "قلعه رييسي", ostan: 23 },
    {
      value: 960,
      label: "دوگنبدان",
      ostan: 23,
    },
    { value: 961, label: "لنده", ostan: 23 },
    { value: 962, label: "آزادشهر", ostan: 24 },
    {
      value: 963,
      label: "نگين شهر",
      ostan: 24,
    },
    { value: 964, label: "نوده خاندوز", ostan: 24 },
    { value: 965, label: "آق قلا", ostan: 24 },
    {
      value: 966,
      label: "انبارآلوم",
      ostan: 24,
    },
    { value: 967, label: "بندرگز", ostan: 24 },
    { value: 968, label: "نوکنده", ostan: 24 },
    {
      value: 969,
      label: "بندرترکمن",
      ostan: 24,
    },
    { value: 970, label: "تاتارعليا", ostan: 24 },
    { value: 971, label: "خان ببين", ostan: 24 },
    {
      value: 972,
      label: "دلند",
      ostan: 24,
    },
    { value: 973, label: "راميان", ostan: 24 },
    { value: 974, label: "سنگدوين", ostan: 24 },
    {
      value: 975,
      label: "علي اباد",
      ostan: 24,
    },
    { value: 976, label: "فاضل آباد", ostan: 24 },
    { value: 977, label: "مزرعه", ostan: 24 },
    {
      value: 978,
      label: "کردکوي",
      ostan: 24,
    },
    { value: 979, label: "فراغي", ostan: 24 },
    { value: 980, label: "کلاله", ostan: 24 },
    {
      value: 981,
      label: "گاليکش",
      ostan: 24,
    },
    { value: 982, label: "جلين", ostan: 24 },
    { value: 983, label: "سرخنکلاته", ostan: 24 },
    {
      value: 984,
      label: "گرگان",
      ostan: 24,
    },
    { value: 985, label: "سيمين شهر", ostan: 24 },
    { value: 986, label: "گميش تپه", ostan: 24 },
    {
      value: 987,
      label: "اينچه برون",
      ostan: 24,
    },
    { value: 988, label: "گنبدکاووس", ostan: 24 },
    { value: 989, label: "مراوه", ostan: 24 },
    {
      value: 990,
      label: "مينودشت",
      ostan: 24,
    },
    { value: 991, label: "آستارا", ostan: 25 },
    { value: 992, label: "لوندويل", ostan: 25 },
    {
      value: 993,
      label: "آستانه اشرفيه",
      ostan: 25,
    },
    { value: 994, label: "کياشهر", ostan: 25 },
    { value: 995, label: "املش", ostan: 25 },
    {
      value: 996,
      label: "رانکوه",
      ostan: 25,
    },
    { value: 997, label: "بندرانزلي", ostan: 25 },
    { value: 998, label: "خشکبيجار", ostan: 25 },
    {
      value: 999,
      label: "خمام",
      ostan: 25,
    },
    { value: 1000, label: "رشت", ostan: 25 },
    { value: 1001, label: "سنگر", ostan: 25 },
    {
      value: 1002,
      label: "کوچصفهان",
      ostan: 25,
    },
    { value: 1003, label: "لشت نشاء", ostan: 25 },
    { value: 1004, label: "لولمان", ostan: 25 },
    {
      value: 1005,
      label: "پره سر",
      ostan: 25,
    },
    { value: 1006, label: "رضوانشهر", ostan: 25 },
    { value: 1007, label: "بره سر", ostan: 25 },
    {
      value: 1008,
      label: "توتکابن",
      ostan: 25,
    },
    { value: 1009, label: "جيرنده", ostan: 25 },
    { value: 1010, label: "رستم آباد", ostan: 25 },
    {
      value: 1011,
      label: "رودبار",
      ostan: 25,
    },
    { value: 1012, label: "لوشان", ostan: 25 },
    { value: 1013, label: "منجيل", ostan: 25 },
    {
      value: 1014,
      label: "چابکسر",
      ostan: 25,
    },
    { value: 1015, label: "رحيم آباد", ostan: 25 },
    { value: 1016, label: "رودسر", ostan: 25 },
    {
      value: 1017,
      label: "کلاچاي",
      ostan: 25,
    },
    { value: 1018, label: "واجارگاه", ostan: 25 },
    { value: 1019, label: "ديلمان", ostan: 25 },
    {
      value: 1020,
      label: "سياهکل",
      ostan: 25,
    },
    { value: 1021, label: "احمدسرگوراب", ostan: 25 },
    { value: 1022, label: "شفت", ostan: 25 },
    {
      value: 1023,
      label: "صومعه سرا",
      ostan: 25,
    },
    { value: 1024, label: "گوراب زرميخ", ostan: 25 },
    { value: 1025, label: "مرجقل", ostan: 25 },
    {
      value: 1026,
      label: "اسالم",
      ostan: 25,
    },
    { value: 1027, label: "چوبر", ostan: 25 },
    { value: 1028, label: "حويق", ostan: 25 },
    {
      value: 1029,
      label: "ليسار",
      ostan: 25,
    },
    { value: 1030, label: "هشتپر (تالش)", ostan: 25 },
    { value: 1031, label: "فومن", ostan: 25 },
    {
      value: 1032,
      label: "ماسوله",
      ostan: 25,
    },
    { value: 1033, label: "ماکلوان", ostan: 25 },
    { value: 1034, label: "رودبنه", ostan: 25 },
    {
      value: 1035,
      label: "لاهيجان",
      ostan: 25,
    },
    { value: 1036, label: "اطاقور", ostan: 25 },
    { value: 1037, label: "چاف و چمخاله", ostan: 25 },
    {
      value: 1038,
      label: "شلمان",
      ostan: 25,
    },
    { value: 1039, label: "کومله", ostan: 25 },
    { value: 1040, label: "لنگرود", ostan: 25 },
    {
      value: 1041,
      label: "بازار جمعه",
      ostan: 25,
    },
    { value: 1042, label: "ماسال", ostan: 25 },
    { value: 1043, label: "ازنا", ostan: 26 },
    { value: 1044, label: "مومن آباد", ostan: 26 },
    {
      value: 1045,
      label: "اليگودرز",
      ostan: 26,
    },
    { value: 1046, label: "شول آباد", ostan: 26 },
    { value: 1047, label: "اشترينان", ostan: 26 },
    {
      value: 1048,
      label: "بروجرد",
      ostan: 26,
    },
    { value: 1049, label: "پلدختر", ostan: 26 },
    { value: 1050, label: "معمولان", ostan: 26 },
    {
      value: 1051,
      label: "بيران شهر",
      ostan: 26,
    },
    { value: 1052, label: "خرم آباد", ostan: 26 },
    { value: 1053, label: "زاغه", ostan: 26 },
    {
      value: 1054,
      label: "سپيددشت",
      ostan: 26,
    },
    { value: 1055, label: "نورآباد", ostan: 26 },
    { value: 1056, label: "هفت چشمه", ostan: 26 },
    {
      value: 1057,
      label: "چالانچولان",
      ostan: 26,
    },
    { value: 1058, label: "دورود", ostan: 26 },
    { value: 1059, label: "سراب دوره", ostan: 26 },
    {
      value: 1060,
      label: "ويسيان",
      ostan: 26,
    },
    { value: 1061, label: "چقابل", ostan: 26 },
    { value: 1062, label: "الشتر", ostan: 26 },
    {
      value: 1063,
      label: "فيروزآباد",
      ostan: 26,
    },
    { value: 1064, label: "درب گنبد", ostan: 26 },
    { value: 1065, label: "کوهدشت", ostan: 26 },
    {
      value: 1066,
      label: "کوهناني",
      ostan: 26,
    },
    { value: 1067, label: "گراب", ostan: 26 },
    { value: 1068, label: "آمل", ostan: 27 },
    {
      value: 1069,
      label: "امامزاده عبدالله",
      ostan: 27,
    },
    { value: 1070, label: "دابودشت", ostan: 27 },
    { value: 1071, label: "رينه", ostan: 27 },
    {
      value: 1072,
      label: "گزنک",
      ostan: 27,
    },
    { value: 1073, label: "اميرکلا", ostan: 27 },
    { value: 1074, label: "بابل", ostan: 27 },
    {
      value: 1075,
      label: "خوش رودپي",
      ostan: 27,
    },
    { value: 1076, label: "زرگرمحله", ostan: 27 },
    { value: 1077, label: "گتاب", ostan: 27 },
    {
      value: 1078,
      label: "گلوگاه",
      ostan: 27,
    },
    { value: 1079, label: "مرزيکلا", ostan: 27 },
    { value: 1080, label: "بابلسر", ostan: 27 },
    {
      value: 1081,
      label: "بهنمير",
      ostan: 27,
    },
    { value: 1082, label: "هادي شهر", ostan: 27 },
    { value: 1083, label: "بهشهر", ostan: 27 },
    {
      value: 1084,
      label: "خليل شهر",
      ostan: 27,
    },
    { value: 1085, label: "رستمکلا", ostan: 27 },
    { value: 1086, label: "تنکابن", ostan: 27 },
    {
      value: 1087,
      label: "خرم آباد",
      ostan: 27,
    },
    { value: 1088, label: "شيرود", ostan: 27 },
    { value: 1089, label: "نشتارود", ostan: 27 },
    {
      value: 1090,
      label: "جويبار",
      ostan: 27,
    },
    { value: 1091, label: "کوهي خيل", ostan: 27 },
    { value: 1092, label: "چالوس", ostan: 27 },
    {
      value: 1093,
      label: "مرزن آباد",
      ostan: 27,
    },
    { value: 1094, label: "هچيرود", ostan: 27 },
    { value: 1095, label: "رامسر", ostan: 27 },
    {
      value: 1096,
      label: "کتالم وسادات شهر",
      ostan: 27,
    },
    { value: 1097, label: "پايين هولار", ostan: 27 },
    { value: 1098, label: "ساري", ostan: 27 },
    {
      value: 1099,
      label: "فريم",
      ostan: 27,
    },
    { value: 1100, label: "کياسر", ostan: 27 },
    { value: 1101, label: "آلاشت", ostan: 27 },
    {
      value: 1102,
      label: "پل سفيد",
      ostan: 27,
    },
    { value: 1103, label: "زيرآب", ostan: 27 },
    { value: 1104, label: "شيرگاه", ostan: 27 },
    {
      value: 1105,
      label: "کياکلا",
      ostan: 27,
    },
    { value: 1106, label: "سلمان شهر", ostan: 27 },
    { value: 1107, label: "عباس اباد", ostan: 27 },
    {
      value: 1108,
      label: "کلارآباد",
      ostan: 27,
    },
    { value: 1109, label: "فريدونکنار", ostan: 27 },
    { value: 1110, label: "ارطه", ostan: 27 },
    {
      value: 1111,
      label: "قايم شهر",
      ostan: 27,
    },
    { value: 1112, label: "کلاردشت", ostan: 27 },
    { value: 1113, label: "گلوگاه", ostan: 27 },
    {
      value: 1114,
      label: "سرخرود",
      ostan: 27,
    },
    { value: 1115, label: "محمودآباد", ostan: 27 },
    { value: 1116, label: "سورک", ostan: 27 },
    {
      value: 1117,
      label: "نکا",
      ostan: 27,
    },
    { value: 1118, label: "ايزدشهر", ostan: 27 },
    { value: 1119, label: "بلده", ostan: 27 },
    {
      value: 1120,
      label: "چمستان",
      ostan: 27,
    },
    { value: 1121, label: "رويان", ostan: 27 },
    { value: 1122, label: "نور", ostan: 27 },
    {
      value: 1123,
      label: "پول",
      ostan: 27,
    },
    { value: 1124, label: "کجور", ostan: 27 },
    { value: 1125, label: "نوشهر", ostan: 27 },
    {
      value: 1126,
      label: "آشتيان",
      ostan: 28,
    },
    { value: 1127, label: "اراک", ostan: 28 },
    { value: 1128, label: "داودآباد", ostan: 28 },
    {
      value: 1129,
      label: "ساروق",
      ostan: 28,
    },
    { value: 1130, label: "کارچان", ostan: 28 },
    { value: 1131, label: "تفرش", ostan: 28 },
    {
      value: 1132,
      label: "خمين",
      ostan: 28,
    },
    { value: 1133, label: "قورچي باشي", ostan: 28 },
    { value: 1134, label: "جاورسيان", ostan: 28 },
    {
      value: 1135,
      label: "خنداب",
      ostan: 28,
    },
    { value: 1136, label: "دليجان", ostan: 28 },
    { value: 1137, label: "نراق", ostan: 28 },
    {
      value: 1138,
      label: "پرندک",
      ostan: 28,
    },
    { value: 1139, label: "خشکرود", ostan: 28 },
    { value: 1140, label: "رازقان", ostan: 28 },
    {
      value: 1141,
      label: "زاويه",
      ostan: 28,
    },
    { value: 1142, label: "مامونيه", ostan: 28 },
    { value: 1143, label: "آوه", ostan: 28 },
    {
      value: 1144,
      label: "ساوه",
      ostan: 28,
    },
    { value: 1145, label: "غرق آباد", ostan: 28 },
    { value: 1146, label: "نوبران", ostan: 28 },
    {
      value: 1147,
      label: "آستانه",
      ostan: 28,
    },
    { value: 1148, label: "توره", ostan: 28 },
    { value: 1149, label: "شازند", ostan: 28 },
    {
      value: 1150,
      label: "شهباز",
      ostan: 28,
    },
    { value: 1151, label: "مهاجران", ostan: 28 },
    { value: 1152, label: "هندودر", ostan: 28 },
    {
      value: 1153,
      label: "خنجين",
      ostan: 28,
    },
    { value: 1154, label: "فرمهين", ostan: 28 },
    { value: 1155, label: "کميجان", ostan: 28 },
    {
      value: 1156,
      label: "ميلاجرد",
      ostan: 28,
    },
    { value: 1157, label: "محلات", ostan: 28 },
    { value: 1158, label: "نيمور", ostan: 28 },
    {
      value: 1159,
      label: "ابوموسي",
      ostan: 29,
    },
    { value: 1160, label: "بستک", ostan: 29 },
    { value: 1161, label: "جناح", ostan: 29 },
    {
      value: 1162,
      label: "سردشت",
      ostan: 29,
    },
    { value: 1163, label: "گوهران", ostan: 29 },
    { value: 1164, label: "بندرعباس", ostan: 29 },
    {
      value: 1165,
      label: "تازيان پايين",
      ostan: 29,
    },
    { value: 1166, label: "تخت", ostan: 29 },
    { value: 1167, label: "فين", ostan: 29 },
    {
      value: 1168,
      label: "قلعه قاضي",
      ostan: 29,
    },
    { value: 1169, label: "بندرلنگه", ostan: 29 },
    { value: 1170, label: "چارک", ostan: 29 },
    {
      value: 1171,
      label: "کنگ",
      ostan: 29,
    },
    { value: 1172, label: "کيش", ostan: 29 },
    { value: 1173, label: "لمزان", ostan: 29 },
    {
      value: 1174,
      label: "پارسيان",
      ostan: 29,
    },
    { value: 1175, label: "دشتي", ostan: 29 },
    { value: 1176, label: "کوشکنار", ostan: 29 },
    {
      value: 1177,
      label: "بندرجاسک",
      ostan: 29,
    },
    { value: 1178, label: "حاجي اباد", ostan: 29 },
    { value: 1179, label: "سرگز", ostan: 29 },
    {
      value: 1180,
      label: "فارغان",
      ostan: 29,
    },
    { value: 1181, label: "خمير", ostan: 29 },
    { value: 1182, label: "رويدر", ostan: 29 },
    {
      value: 1183,
      label: "بيکاء",
      ostan: 29,
    },
    { value: 1184, label: "دهبارز", ostan: 29 },
    { value: 1185, label: "زيارتعلي", ostan: 29 },
    {
      value: 1186,
      label: "سيريک",
      ostan: 29,
    },
    { value: 1187, label: "کوهستک", ostan: 29 },
    { value: 1188, label: "گروک", ostan: 29 },
    {
      value: 1189,
      label: "درگهان",
      ostan: 29,
    },
    { value: 1190, label: "سوزا", ostan: 29 },
    { value: 1191, label: "قشم", ostan: 29 },
    {
      value: 1192,
      label: "هرمز",
      ostan: 29,
    },
    { value: 1193, label: "تيرور", ostan: 29 },
    { value: 1194, label: "سندرک", ostan: 29 },
    {
      value: 1195,
      label: "ميناب",
      ostan: 29,
    },
    { value: 1196, label: "هشتبندي", ostan: 29 },
    { value: 1197, label: "آجين", ostan: 30 },
    {
      value: 1198,
      label: "اسدآباد",
      ostan: 30,
    },
    { value: 1199, label: "بهار", ostan: 30 },
    { value: 1200, label: "صالح آباد", ostan: 30 },
    {
      value: 1201,
      label: "لالجين",
      ostan: 30,
    },
    { value: 1202, label: "مهاجران", ostan: 30 },
    { value: 1203, label: "تويسرکان", ostan: 30 },
    {
      value: 1204,
      label: "سرکان",
      ostan: 30,
    },
    { value: 1205, label: "فرسفج", ostan: 30 },
    { value: 1206, label: "دمق", ostan: 30 },
    {
      value: 1207,
      label: "رزن",
      ostan: 30,
    },
    { value: 1208, label: "قروه درجزين", ostan: 30 },
    { value: 1209, label: "فامنين", ostan: 30 },
    {
      value: 1210,
      label: "شيرين سو",
      ostan: 30,
    },
    { value: 1211, label: "کبودرآهنگ", ostan: 30 },
    { value: 1212, label: "گل تپه", ostan: 30 },
    {
      value: 1213,
      label: "ازندريان",
      ostan: 30,
    },
    { value: 1214, label: "جوکار", ostan: 30 },
    { value: 1215, label: "زنگنه", ostan: 30 },
    {
      value: 1216,
      label: "سامن",
      ostan: 30,
    },
    { value: 1217, label: "ملاير", ostan: 30 },
    { value: 1218, label: "برزول", ostan: 30 },
    {
      value: 1219,
      label: "فيروزان",
      ostan: 30,
    },
    { value: 1220, label: "گيان", ostan: 30 },
    { value: 1221, label: "نهاوند", ostan: 30 },
    {
      value: 1222,
      label: "جورقان",
      ostan: 30,
    },
    { value: 1223, label: "قهاوند", ostan: 30 },
    { value: 1224, label: "مريانج", ostan: 30 },
    {
      value: 1225,
      label: "همدان",
      ostan: 30,
    },
    { value: 1226, label: "ابرکوه", ostan: 31 },
    { value: 1227, label: "مهردشت", ostan: 31 },
    {
      value: 1228,
      label: "احمدآباد",
      ostan: 31,
    },
    { value: 1229, label: "اردکان", ostan: 31 },
    { value: 1230, label: "عقدا", ostan: 31 },
    {
      value: 1231,
      label: "اشکذر",
      ostan: 31,
    },
    { value: 1232, label: "خضرآباد", ostan: 31 },
    { value: 1233, label: "بافق", ostan: 31 },
    {
      value: 1234,
      label: "بهاباد",
      ostan: 31,
    },
    { value: 1235, label: "تفت", ostan: 31 },
    { value: 1236, label: "نير", ostan: 31 },
    {
      value: 1237,
      label: "مروست",
      ostan: 31,
    },
    { value: 1238, label: "هرات", ostan: 31 },
    { value: 1239, label: "مهريز", ostan: 31 },
    {
      value: 1240,
      label: "بفروييه",
      ostan: 31,
    },
    { value: 1241, label: "ميبد", ostan: 31 },
    { value: 1242, label: "ندوشن", ostan: 31 },
    {
      value: 1243,
      label: "حميديا",
      ostan: 31,
    },
    { value: 1244, label: "زارچ", ostan: 31 },
    { value: 1245, label: "شاهديه", ostan: 31 },
    {
      value: 1246,
      label: "يزد",
      ostan: 31,
    },
  ],
};
